import { FC } from 'react';

export const Printer: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6 6C6 4.89543 6.89543 4 8 4H16C17.1046 4 18 4.89543 18 6V8C19.6569 8 21 9.34315 21 11V16C21 17.6569 19.6569 19 18 19V20C18 21.1046 17.1046 22 16 22H8C6.89543 22 6 21.1046 6 20V19C4.34315 19 3 17.6569 3 16V11C3 9.34315 4.34315 8 6 8V6ZM8 8H16V6H8V8ZM8 20H16V16H8V20ZM18 17C18.5523 17 19 16.5523 19 16V11C19 10.4477 18.5523 10 18 10H6C5.44772 10 5 10.4477 5 11V16C5 16.5523 5.44772 17 6 17V16C6 14.8954 6.89543 14 8 14H16C17.1046 14 18 14.8954 18 16V17ZM9 18C9 17.4477 9.44772 17 10 17H14C14.5523 17 15 17.4477 15 18C15 18.5523 14.5523 19 14 19H10C9.44772 19 9 18.5523 9 18Z"
			fill="currentColor"
		/>
	</svg>
);
